<main role="main" #schedule id="conference-scheduler-main" style="margin-left: 20px; margin-right: 20px">
  <nav *ngIf="initialized" class="navbar navbar-dark navbar-dark" style="border-bottom: 1px solid #cbd6e2">
    <div class="form-inline">
      <label class="mr-1" for="inlineFormInputName2">Timezone: {{ schedulerSettings.timeZone }}</label>
      <strong> </strong>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <button *ngIf="currentDay > 0" class="btn btn-icon btn-white mr-1 font-size-3" type="button" (click)="previousDay()"><i class="fas fa-arrow-alt-square-left btn-icon__inner"></i></button>
      <h5 class="mb-0">{{ schedulerSettings.currentDateFormatted }}</h5>
      <button *ngIf="currentDay < schedulerSettings.numberOfDays - 1" class="btn btn-icon btn-white ml-1 font-size-3" (click)="nextDay()" type="button"><i class="fas fa-arrow-alt-square-right btn-icon__inner"></i></button>
    </div>
  </nav>
  <div class="row no-gutters no-candidates m-6" style="min-height: 200px" *ngIf="initialized && (!rooms || rooms.length == 0)">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>No Events</h4>
      <p>No Events have been scheduled for this day.</p>
    </div>
  </div>
  <page-load-header *ngIf="loading"></page-load-header>
  <div *ngIf="!loading && rooms && rooms.length > 0" class="container-fluid bg-white container-separator pl-0 pr-0 conference-scheduler" style="">
    <table class="table" style="border-left: 1px solid #ccc">
      <thead>
        <tr>
          <th [style.width.px]="80">Time</th>
          <th [style.width.px]="colWidth" *ngFor="let room of rooms">{{ room.roomName }}
            <div  class="d-block text-muted" style="font-size: 12px">&nbsp;{{ room.subjectOrTrackName }}</div>
          </th>
        </tr>
      </thead>
      <tbody class="drag-boundary">
        <div style="position: relative">
          <div *ngFor="let evt of events" class="scheduler-event" (click)="showDetails(evt)" [style.background]="evt.schedulerColor" [style.color]="evt.schedulerColor | invertColor" [style.height.px]="evt.durationIn5MinBlocks * 7" [style.width.px]="colWidth * evt.roomSpan" [ngStyle]="{ transform: 'translate3d(' + evt.xCoordinate + 'px, ' + evt.yCoordinate + 'px,0)' }">
            <div class="d-flex align-items-start flex-column scheduler-event-item">
              <span class="title mb-auto">{{ evt.title }}</span>

              <span class="instructor d-flex mb-auto justify-content-between w-100" *ngIf="evt.durationIn5MinBlocks <= 6">
                <span *ngFor="let instructor of evt.allInstructors; let isLast = last">{{ instructor.lastName }}{{ isLast ? '' : ', ' }}</span>
                <span>{{ evt.contentArea }}</span>
                <span>{{ evt.ceus | ceuDisplay: true }} CEUs</span>
              </span>
              <span *ngIf="evt.durationIn5MinBlocks > 6" class="instructor mb-auto"
                ><span class="" *ngFor="let instructor of evt.allInstructors; let isLast = last">{{ instructor.lastName }}{{ isLast ? '' : ', ' }}</span></span
              >
              <span *ngIf="evt.durationIn5MinBlocks > 6" class="d-flex mb-auto justify-content-between w-100">
                <span class="">{{ evt.contentArea }}</span>
                <span class="ceu">{{ evt.ceus | ceuDisplay: true }} CEU</span>
              </span>
            </div>
            <div class="tooltip-div p-1 font-size-1" style="top: 0; display: none; position: absolute; z-index: 99999; width: 100%; background-color: #ececec; border: 1px solid #b9b8b8; border-radius: 3px; color: black;">
                <div style="line-height: 14px;">{{ evt.startTimeInTimeZone | date: 'shortTime' }} - {{ evt.endTimeInTimeZone | date: 'shortTime' }} <br><span style="font-size: 12px;line-height: 12px;font-weight:600">{{ evt.ceus | ceuDisplay }} CEU</span></div>
            </div>
          </div>
        </div>
        <!-- <tr>
          <td [attr.colspan]="rooms.length +1"></td>

        </tr> -->
        <tr *ngFor="let time of timeBlocks">
          <td>{{ time }}</td>
          <td *ngFor="let room of rooms"></td>
        </tr>
      </tbody>
    </table>
  </div>
</main>
